import { getPermission, IMenuItem } from 'O3_core';
import { JOB_DEFINITION_RESOURCE, JOB_DEFINITION_SCOPES } from '../job-definition/constants/job-definition.constants';
import { JOB_EXECUTION_RESOURCE, JOB_EXECUTION_SCOPES } from '../job-execution/constants/job-execution.constants';

export const JobSchedulerSMIs: IMenuItem[] = [
  {
    id: '10000',
    label: 'sideMenuItems.jobScheduler._label',
    icon: 'ti ti-calendar-clock',
    items: [
      {
        id: '10001',
        label: 'sideMenuItems.jobScheduler.dashboard',
        icon: 'ti ti-layout-dashboard',
        routerLink: '/job-scheduler',
        permission: getPermission(JOB_DEFINITION_RESOURCE, JOB_DEFINITION_SCOPES.SideMenuItem),
      },
      {
        id: '10002',
        label: 'sideMenuItems.jobScheduler.jobDefinitions',
        icon: 'ti ti-settings-2',
        routerLink: '/job-scheduler/definitions',
        permission: getPermission(JOB_DEFINITION_RESOURCE, JOB_DEFINITION_SCOPES.SideMenuItem),
      },
      {
        id: '10003',
        label: 'sideMenuItems.jobScheduler.jobExecutions',
        icon: 'ti ti-history',
        routerLink: '/job-scheduler/executions',
        permission: getPermission(JOB_EXECUTION_RESOURCE, JOB_EXECUTION_SCOPES.SideMenuItem),
      },
    ],
  },
];
